export function getUrlParamByName(name: string) {
  const params = new URLSearchParams(window.location.search);
  if (!params.has(name)) return null;
  return params.get(name);
}
